import { render, staticRenderFns } from "./BuyResult.vue?vue&type=template&id=4c1d43f0&"
import script from "./BuyResult.vue?vue&type=script&lang=js&"
export * from "./BuyResult.vue?vue&type=script&lang=js&"
import style0 from "./BuyResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports